(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getUtmParams() {
    var raw = getCookie('jd_utm_params');
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function initCountryConditional(formEl) {
    var countryEl = formEl.querySelector('[data-jd-field="country"]');
    var usStateWrap = formEl.querySelector('[data-jd-wrap="us-state"]');
    var countryWarning = formEl.querySelector('[data-jd-country-warning]');
    if (!countryEl || !usStateWrap) return;

    function update() {
      var val = countryEl.value;
      var isUS = val === 'United States';
      usStateWrap.hidden = !isUS;
      var stateSelect = usStateWrap.querySelector('select');
      if (stateSelect) stateSelect.required = isUS;
      if (countryWarning) countryWarning.hidden = val !== 'Other' && val !== 'Canada';
    }

    countryEl.addEventListener('change', update);
    update();
  }

  function initForm(formEl) {
    var statusId = formEl.getAttribute('data-status-id');
    var statusEl = statusId ? document.getElementById(statusId) : null;
    var submitBtn = formEl.querySelector('.jd-form-submit');
    var originalBtnText = submitBtn ? submitBtn.textContent.trim() : 'Submit';

    initCountryConditional(formEl);

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!formEl.checkValidity()) {
        formEl.reportValidity();
        return;
      }

      var scriptUrl = formEl.dataset.scriptUrl;
      var sheetId = formEl.dataset.sheetId;
      var tabName = formEl.dataset.tabName;
      var gtagCategory = formEl.dataset.gtagCategory;
      var gtagAction = formEl.dataset.gtagAction;
      var gtagLabel = formEl.dataset.gtagLabel;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting\u2026';
      }

      var utm = getUtmParams();
      var formData = new FormData(formEl);
      var data = {
        sheetId: sheetId,
        tabName: tabName,
        Date: new Date().toISOString().replace('T', ' ').substring(0, 19),
        Source: utm.source || '',
        Medium: utm.medium || '',
        Campaign: utm.campaign || '',
        Marketing: utm.marketing || ''
      };

      formData.forEach(function (value, key) {
        data[key] = value;
      });

      fetch(scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(data)
      })
      .then(function () {
        formEl.hidden = true;
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.innerHTML = '<p class="jd-form__success">' + (formEl.dataset.successMessage || 'Thank you \u2014 your submission has been received.') + '</p>';
        }
        if (gtagCategory && typeof gtag === 'function') {
          gtag('event', 'custom_event', {
            event_category: gtagCategory,
            event_action: gtagAction,
            event_label: gtagLabel
          });
        }
        if (formEl.dataset.fbqEvent && typeof fbq === 'function') {
          fbq('trackCustom', formEl.dataset.fbqEvent);
        }
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.innerHTML = '<p class="jd-form__error">' + (formEl.dataset.errorMessage || 'Something went wrong. Please try again.') + '</p>';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.jd-form').forEach(initForm);
  });
})();
